module.exports = __webpack_public_path__ + "img/05.56cb8231.jpg";